// extracted by mini-css-extract-plugin
module.exports = {"card":"PokemonCard_card__Px5N1","text_center":"PokemonCard_text_center__iKWdw"};